

<template>
  <div class="address_container">
    <div class="navbar">
      <navbar :titlename="titlename"></navbar>
    </div>
    <div id="container"></div>
    <div class="adressbox">
      <div class="padding-xl radius shadow bg-white adressboxmain">
        <div class="ad-companyname">公司名字：{{companyData.company_name}}</div>
        <div class="ad-address">
          <van-icon style="margin-right:0.54rem;" name="location-o" color="#999" size="20px" />
          {{companyData.location}}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import navbar from "../public/navbar.vue";
import { TMap } from "../../../src/assets/js/TMap.js";
import Vue from "vue";
import { Icon } from "vant";

Vue.use(Icon);
export default {
  data() {
    return {
      titlename: "查看地址",
      companyData: {
        company_name: "厦门龙商网络有限公司",
        company_remark: "",
        longitude: "118.08243",
        latitude: "24.44579",
        location: "福建省厦门市思明区民族路33号",
        detail: ""
      }
    };
  },
  components: { navbar },
  mounted() {
    this.companyData = this.$route.params.companyData;
    TMap("BOTBZ-KK5WU-L7AVP-2IK2Y-MR3Y3-MDBR4").then(qq => {
      var center = new qq.maps.LatLng(
          this.companyData.latitude,
          this.companyData.longitude
        );
      var map = new qq.maps.Map(document.getElementById("container"), {
        // 地图的中心地理坐标。
        center:center,
        zoom: 18,
        draggable: true,
        scrollwheel: true,
        disableDoubleClickZoom: true
      });

      var marker = new qq.maps.Marker({
          position: center,
          map: map
      });
      
    });
  },
  methods: {},
  created: function() {
    document.title='地址';
  }
};
</script>
<style>
.address_container {
  width: 100%;
  height: 100%;
}
#container {
  width: 100%;
  height: calc(100% - 50px);
}

.adressbox {
  width: 94%;
  margin: 0 auto;
  position: absolute;
  left: 3%;
  bottom: 0.6rem;
  background: #fff;
}
.adressbox .adressboxmain {
  padding: 1.5rem 1.5rem;
}
.adressbox .ad-companyname {
  padding-bottom: 0.9405405405405406rem;
  font-weight: bold;
  color: #333;
  font-size: 0.97rem;
}
.adressbox .ad-address {
  display: flex;
  justify-items: center;
  align-items: center;
  font-size: 0.8648648648648649rem;
  color: #999;
}
.adressbox .ad-address .ad-adicon {
  font-size: 0.8648648648648649rem;
  margin-right: 0.5405405405405406rem;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/address.vue